module.exports = __webpack_public_path__ + "media/panda.c9524145.mp3";